import _ from "underscore";
import moment from "moment";

import Backbone from "pages/common/lib/backbone-helpers";
import { publicRuntimeConfig } from "util/env-utils";

import LiveModel from "../model/dvr/live";
import VODModel from "../model/dvr/vod";
import "./trimmer/gaps";

var DVRBlockCollection = Backbone.Collection.extend({
    comparator: `startTimestamp`,

    initialize: function (models, options) {
        models = _.isArray(models) ? models : [];
        options = _.isObject(options) ? options : {};

        this.startTimestamp = _.isNumber(options.startTimestamp)
            ? options.startTimestamp
            : 0;
        this.endTimestamp = _.isNumber(options.endTimestamp)
            ? options.endTimestamp
            : Infinity;
        this.duration = 0;
        this.streamId = options.streamId;

        _.bindAll(
            this,
            `parse`,
            `startPollingLiveSegment`,
            `onLiveSegmentPollingSuccessful`,
            `resetPollingState`
        );

        this.listenTo(this, `add change reset remove`, this.computeDuration);
        this.listenTo(
            this,
            `add change reset remove sync`,
            this.checkForLiveSegment
        );

        this.listenTo(
            this,
            `change:croppingProperty`,
            this.onCroppingPropertyChange
        );
    },

    parse: function (response) {
        var blocks = _.isArray(response) ? response : response.contentSections;

        var items = [];
        for (var i = 0; i < blocks.length; i++) {
            var item = blocks[i];

            delete item.encodeRenditionId;

            // TODO: REMOVE THAT WHEN THE BACKEND RETURNS RIGHT INFO
            if (
                item.startTimeOffset < 0 ||
                !Object.prototype.hasOwnProperty.call(item, `startTimeOffset`)
            ) {
                item.startTimeOffset = 0;
            }

            if (!_.isNumber(item.endTimestamp)) {
                item.type = `live`;
            } else {
                item.type = `vod`;
            }

            if (item.playlistUrl.indexOf(`http`) !== 0) {
                item.playlistUrl =
                    publicRuntimeConfig.UDVR_URL + item.playlistUrl;
            }

            item.startTimeOffset = 0;
            item.startTimeOffsetInSeconds = 0;

            items.push(item);
        }

        return items;
    },

    model: function (attrs, options) {
        switch (attrs.type) {
            case `vod`:
                return new VODModel(attrs, options);
            case `live`:
                return new LiveModel(attrs, options);
        }
    },

    modelId: function (attrs) {
        return attrs.startTimestamp;
    },

    computeDuration: function () {
        var duration =
            this.reduce(function (memo, model) {
                return memo + model.get(`duration`);
            }, 0) / 1000;
        this.duration = parseFloat(duration, 10);
        this.trigger(`change:duration`, duration);
        return this.duration;
    },

    checkForLiveSegment: function () {
        var liveSegment = this.findWhere({ type: `live` });
        if (!_.isUndefined(liveSegment)) {
            if (this.currentLiveSegment !== liveSegment) {
                // We only want to trigger that there is a new live segment
                // if it was set before. Otherwise that means that we've just
                // landed on the page and we don't need to run the stream
                // recover logic
                var triggerEvt = this.currentLiveSegment ? true : false;
                this.currentLiveSegment = liveSegment;
                this.pollingInterval = setInterval(
                    this.startPollingLiveSegment,
                    5000
                );

                if (triggerEvt) {
                    this.trigger(`new:livesegment`);
                }
            }
        } else {
            clearInterval(this.pollingInterval);
            delete this.pollingInterval;
        }
    },

    startPollingLiveSegment: function () {
        // Since that call can be long we want to avoid having multiple
        // ajax query running at the same time
        if (this.pollingInProgress !== true) {
            var url = `${publicRuntimeConfig.UDVR_URL}/api/v2/dvr/contentmap`;
            var options = {
                streamId: this.streamId,
                allowDiscontinuity: false,
                startTimestamp: this.currentLiveSegment.get(`startTimestamp`)
            };

            this.pollingInProgress = true;
            $.get({
                url: `${url}?${$.param(options)}`,
                xhrFields: { withCredentials: true }
            })
                .done(this.onLiveSegmentPollingSuccessful)
                .catch(this.onLiveSegmentPollingFailure)
                .always(this.resetPollingState);
        }
    },

    onLiveSegmentPollingSuccessful: function (response) {
        var blocks = _.isArray(response) ? response : response.contentSections;

        if (_.isArray(blocks)) {
            if (blocks.length === 1) {
                // TODO: Ask Paco to remove that from the backend. Or to
                // return `Infinity`
                blocks[0].endTimestamp = Infinity;

                // Still our live segment, all good
                // We want to update the collection model to be able to refresh
                // the UI
                this.currentLiveSegment.set(blocks[0]);
            } else if (blocks.length > 1) {
                // One or more discontuinity happened...
                // Let's insert all of that in the collection and mark
                // the current live segment as a VOD playlist

                // And we re-add it, but with it's new parameter, so that
                // it is now instanciated as a "VOD" content

                var oldLiveSegment = blocks.shift();
                oldLiveSegment.type = `vod`;

                var liveSegment = this.get(oldLiveSegment.startTimestamp);

                if (liveSegment) {
                    liveSegment.set(oldLiveSegment);
                }
                this.add(blocks, { parse: true });
            }
        } else {
            // We should always get an array.
            // is it even possible to get here?
        }
    },

    onLiveSegmentPollingFailure: function (xhr) {
        const errorCodeId = xhr.responseJSON.error.errorCodeId;
        const failedDvrFetch = App.Models.selectedStream.get(`failedDvrFetch`);
        switch (errorCodeId) {
            case 200716:
                failedDvrFetch
                    ? null
                    : App.Events.trigger(
                          `change:range`,
                          moment().subtract(4, `hours`).add(1, `minute`),
                          Infinity
                      );
                break;

            case 200721: //## Holder for error condition.
                App.Events.trigger(`change:8HourExceed`);
                clearInterval(this.pollingInterval);
                break;
        }
    },

    /**
     * This method will return you the best seekable timestamp
     * Meaning one that is NOT inside a gap for a given timestamp
     */
    getSeekableTimestamp: function (timestamp) {
        for (var i = 0; i < this.length; i++) {
            var segment = this.at(i);
            // the timestamp is within a segmnet range. it is seekable.
            if (
                timestamp >= segment.get(`startTimestamp`) &&
                timestamp <= segment.get(`endTimestamp`)
            ) {
                return timestamp;
            } else if (timestamp <= segment.get(`startTimestamp`)) {
                // If the timestamp is smaller than the segment startTimestamp
                // it means that the given timestamp is within a "gap",
                // the first seekable timestamp, is the start of that segment
                return segment.get(`startTimestamp`);
            }
        }
    },

    isTimeWithinASegment: function (timestamp) {
        for (var i = 0; i < this.length; i++) {
            var segment = this.at(i);
            if (
                timestamp >= segment.get(`startTimestamp`) &&
                timestamp <= segment.get(`endTimestamp`)
            ) {
                return true;
            }
        }
        return false;
    },

    resetPollingState: function () {
        this.pollingInProgress = false;
    },

    getGapDurationBetween: function (inPoint, outPoint) {
        inPoint = inPoint > 0 ? inPoint : 0;
        outPoint = outPoint > 0 ? outPoint : 0;

        // We select all the segments that contains content between the in and the
        // out point
        var segments = this.chain().filter(function (segment) {
            return (
                inPoint <= segment.get(`endTimestamp`) &&
                outPoint >= segment.get(`startTimestamp`)
            );
        });

        if (segments.value().length === 0) {
            // If there are no segments, then it means that it's an infinite gap, because there's no content
            // available in the user selection
            return Infinity;
        } else {
            // We compute the length of the gaps, i.e. the duration between the start
            // of a segment and the end of the previous one
            var gapDuration = segments
                .reduce(function (duration, segment, index, array) {
                    if (index === 0) {
                        return duration;
                    } else {
                        var previousSegment = array[index - 1];
                        return (
                            duration +
                            (segment.get(`startTimestamp`) -
                                previousSegment.get(`endTimestamp`))
                        );
                    }
                }, 0)
                .value();

            var startOffset = 0;
            var endOffset = 0;

            // If the in point is not in a segment it means that we need to count the
            // duration from the inPoint to the start of the first segment as a "gap" time
            if (!this.isTimeWithinASegment(inPoint)) {
                startOffset =
                    segments.first().value().get(`startTimestamp`) - inPoint;
            }

            // If the out point is not in a segment it means that we need to count the
            // duration from the end of the last segment to the outPoint as a "gap" time
            if (!this.isTimeWithinASegment(outPoint)) {
                endOffset =
                    outPoint - segments.last().value().get(`endTimestamp`);
            }

            // The addition of those three values gives us the gap length
            return startOffset + gapDuration + endOffset;
        }
    },

    getActiveModelForTime: function (time) {
        for (var i = 0; i < this.length; i++) {
            var model = this.at(i);
            if (
                time >= model.get(`startTimestamp`) &&
                time <= model.get(`endTimestamp`)
            ) {
                return model;
            }
        }
    },

    /**
     * We always want all segmnets to have the same croppingProperty
     */
    onCroppingPropertyChange: function (m, value) {
        this.each(function (model) {
            if (m !== model) {
                model.set(
                    {
                        croppingProperty: value
                    },
                    {
                        silent: true
                    }
                );
            }
        }, this);
    }
});

export default DVRBlockCollection;
